import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { IErrorResponse } from "model";
import { IApiResponse } from "model/Common/IApiResponse";

interface IErrorReducer extends IBaseReducerState {
  errors?: IErrorResponse;
}

const initialState: IErrorReducer = {
  action: "ERROR",
  prefix: "ERROR",
};

const ErrorReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder.addMatcher(
      (action) => action.type.includes("_FAILED"),
      (
        state: IErrorReducer,
        action: PayloadAction<IApiResponse<IErrorResponse>>
      ) => {
        state.errors = action.payload;
      }
    );
  }
);

export default ErrorReducer;
